import React, { useState } from 'react';
import axios from 'axios';
import { PASSWORD_POLICY_REGEX } from './Form/validate';

const ExampleModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [result, setResult] = useState('');
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  const handleSubmitClick = async () => {
    if (validateEmail(email) && validatePassword(password)) {
      try {
        const response = await axios.post('https://futureshift.cpslearn.co.za/api/login', {email,password});
        setResult(response.data.status);
        if (response.data.userId) setModalOpen(false);
      } catch (error) {
        console.error(error);
        setError(error.message);
      }
    } else {
      setError("Not Valid");
    }
  }
  
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function validatePassword(password) {
    return PASSWORD_POLICY_REGEX.test(password);
  }

  return (
    <div>
      <button style={{ position: "absolute", top: "10px", left: "10px" }} onClick={() => setModalOpen(true)}>Open Modal</button>
      {modalOpen && (
        <div style={{ backgroundColor: result === "success" ? "green" : "gray", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ backgroundColor: "white", width: "30%", height: "30%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <p>Login</p>
            <div>
              <input type="text" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)}/>
            </div>
            <div>
              <input type={showPassword ? "text" : "password"} placeholder="Password" value={password} onChange={e =>  setPassword(e.target.value)}/>
              <button onClick={() => setShowPassword(!showPassword)}>Toggle Password</button>
            </div>
            <button onClick={handleSubmitClick}>Submit</button>
            <button onClick={() => setModalOpen(false)}>Cancel</button>
            {error && <p style={{color: 'red'}}>{error}</p>}
            {result && <p style={{color: 'green'}}>{result}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExampleModal;


